import {
	useProducts,
	useProductsFilters
} from "lib/products"
import { useTranslation } from "lib/i18n/translation"

export default () => {
	const { c } = useTranslation("common")
	const { totalProductsCount, productsCount } = useProducts()
	const { loading } = useProductsFilters()

	return (
		<span className="film-counter"><strong>{loading ? <span className="loader" /> : productsCount}</strong> / {totalProductsCount} {c("quoted-films")}</span>
	)
}
